module.exports = __webpack_public_path__ + "static/1-d70f6a8bb7802f902837194c76b50ebc.png";